export default __webpack_public_path__ + "static/media/boxmail.21822a3e.svg";